import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Backend base URL: strip /api suffix to get the root
const BACKEND_URL = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');

const errorMessages = {
  oauth_error: 'OAuth hiba történt. Próbáld újra.',
  invalid_state: 'Érvénytelen munkamenet. Próbáld újra.',
  forbidden: 'Nincs jogosultságod belépni (nem vagy Administrators csoportban).',
  auth_failed: 'Hitelesítés sikertelen. Próbáld újra.',
};

export default function Login() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  useEffect(() => {
    // If already has valid token, redirect to dashboard
    const token = localStorage.getItem('token');
    if (token) {
      window.location.href = '/';
    }
  }, []);

  const handleLogin = () => {
    window.location.href = `${BACKEND_URL}/auth/login`;
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-icon">🎓</div>
        <h1 className="login-title">UniTracker</h1>
        <p className="login-subtitle">Hiányzáskövetés</p>

        {error && (
          <div className="error-banner">
            {errorMessages[error] || 'Ismeretlen hiba történt.'}
          </div>
        )}

        <button className="login-btn" onClick={handleLogin}>
          <svg viewBox="0 0 24 24" fill="none" className="login-btn-icon">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <path d="M8 12h8M12 8l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Belépés Authentik-kel
        </button>
      </div>
    </div>
  );
}
